<!-- 通用流程表单H5 -->
<template>
  <div class="flowForm">
    <!-- 表单 -->
    <van-form ref="formData" :readonly="flowStatus">
      <van-field v-model.trim="formData.title" name="title" label="标题" placeholder="标题" maxlength="30" clearable :rules="[{ required: true, message: '请填写标题' }]" />
      <van-field readonly :is-link="!flowStatus" :value="formData.specName" label="专业" placeholder="专业" @click="flowStatus ? '' : (showSpecId = true)" />
      <van-field v-model.trim="formData.stage" name="stage" label="阶段" placeholder="阶段" maxlength="30" clearable />
      <van-field readonly :is-link="!flowStatus" :value="formData.daterange" label="起讫时间" placeholder="起讫时间" @click="flowStatus ? '' : (showDaterange = true)" />
      <van-field readonly :is-link="!flowStatus" :value="formData.prjPlanName" label="关联计划" placeholder="关联计划" @click="openPriPlan" />
      <template v-if="flowStatus">
        <van-field v-model="formData.prjName" label="项目名称" placeholder="项目名称" />
        <van-field v-model="formData.prjCode" label="项目编号" placeholder="项目编号" />
        <van-field v-model="formData.operUserName" label="申请人" placeholder="申请人" />
        <van-field v-model="formData.operTime" label="提交时间" placeholder="提交时间" />
      </template>
      <van-field v-model.trim="formData.content" label="内容" placeholder="内容" type="textarea" maxlength="200" show-word-limit clearable />
      <van-field readonly label="附件">
        <template #button>
          <van-button v-if="!flowStatus" size="mini" type="primary" native-type="button" @click="openFileTree">关联文档</van-button>
        </template>
      </van-field>
    </van-form>

    <!-- 专业弹框 -->
    <van-popup v-model="showSpecId" round position="bottom">
      <van-picker v-if="specList?.length" :columns="specList">
        <template #option="option">
          <div class="oneCell" @click="spacConfirm(option)">{{ option.name }}</div>
        </template>
      </van-picker>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
    <!-- 日期选择 -->
    <van-calendar ref="calendar" v-model="showDaterange" type="range" color="#1989fa" :min-date="minDate" :max-date="maxDate" :show-confirm="false" @confirm="dateConfirm" />
    <!-- 关联计划弹框 -->
    <van-popup v-model="showPrjPlan" round position="bottom">
      <van-picker v-if="prjPlanList?.length" :columns="prjPlanList">
        <template #option="option">
          <div class="oneCell" @click="priPlanConfirm(option)">{{ option.name }}</div>
        </template>
      </van-picker>
      <div v-else class="empty">暂无数据</div>
    </van-popup>
    <!-- 关联文档弹框 -->
    <treeLazyH5 ref="treeLazyH5" :load="getFileTree" @check-change="fileCheck"></treeLazyH5>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { dateFormatter } from "@/CommonDP/utils/common";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import flowService from "@/CommonDP/service/flow-service";
import docService from "@/CommonDP/service/doc-service";
import treeLazyH5 from "@/CommonDP/components/treeLazyH5";
import moment from "moment";

// 初始化表单
function FormData() {
  return {
    title: "",
    specId: "",
    specName: "",
    stage: "",
    daterange: "", // 日期范围
    startDate: "",
    endDate: "",
    prjPlanId: "", // 关联计划
    prjPlanName: "",
    prjName: "",
    prjCode: "",
    operUserName: "",
    operTime: "",
    content: ""
  };
}

export default {
  components: { treeLazyH5 },
  props: {
    uuid: {
      type: String,
      default: ""
    }, // 唯一标识
    flowDefinitionId: {
      type: String,
      default: ""
    } // 流程版本号。与 flowKey 两者不可同时为空
  },
  data() {
    return {
      formData: new FormData(), // 表单数据
      flowStatus: false,

      showSpecId: false, // 专业选择
      specList: [],
      showDaterange: false, // 日期选择
      minDate: moment().subtract(1, "y").toDate(),
      maxDate: moment().add(1, "y").toDate(),
      showPrjPlan: false, // 关联计划选择
      prjPlanList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo
    }),
    // 流程基本信息
    flowInfo() {
      return getApprove(this.uuid)?.getMessage();
    },
    approveInfo() {
      return getApprove(this.uuid);
    },
    prjId() {
      return this.approveInfo.getPrjId() || this.prjInfo.prjId;
    }
  },
  watch: {
    "formData.specId"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = "";
        this.formData.prjPlanName = "";
        this.prjPlanList = [];
      }
    }
  },
  mounted() {
    this.formData.title = this.userInfo?.name + "发起" + (this.flowInfo.flowName || "流程");
    if (this.prjId) this.getSpecList();
  },
  methods: {
    // 接口：用于获取表单数据
    getFormData() {
      // 接口：用于获取表单数据
      return {
        ...this.formData,
        prjId: this.prjId
      };
    },
    // 接口：设置表单数据
    setFormData(formData) {
      this.formData = formData;
      this.setDaterange();
    },
    // 接口：校验表单数据
    async validateFormData() {
      let flag = null;
      await this.$refs.formData
        .validate()
        .then(() => {
          flag = true; // 验证通过
        })
        .catch(() => {});
      return flag;
    },

    // 重置表单数据
    resetForm() {
      this.formData = new FormData();
      this.formData.title = this.userInfo?.name + "发起" + (this.flowInfo.flowName || "流程");
    },
    // 禁用表单
    disableForm() {
      this.flowStatus = true;
    },

    // 获得专业列表
    async getSpecList() {
      const { data } = await flowService.querySpecList(this.prjId);
      if (data) this.specList = data.flowSpecPoList || [];
    },
    // 确定专业
    spacConfirm(option) {
      if (option) {
        this.formData.specId = option.id || "";
        this.formData.specName = option.name || "";
      }
      this.$emit("change_showStartButtons");
      this.formData.prjPlanId = "";
      this.formData.prjPlanName = "";
      this.showSpecId = false;
    },
    // 设置默认日期
    setDaterange() {
      const { startDate, endDate } = this.formData || {};
      if (startDate) {
        this.formData.daterange = startDate + " 至 " + endDate;
        const start = moment(startDate, "yyyy-MM-dd").toDate();
        const end = moment(endDate, "yyyy-MM-dd").toDate();
        const dates = [start, end];
        this.$refs.calendar.reset(dates);
      } else {
        this.formData.daterange = "";
        this.$refs.calendar.reset();
      }
    },
    // 确定日期
    dateConfirm(dates) {
      if (dates) {
        this.formData.startDate = dateFormatter(dates[0], "yyyy-MM-dd");
        this.formData.endDate = dateFormatter(dates[1], "yyyy-MM-dd");
        this.formData.daterange = this.formData.startDate + " 至 " + this.formData.endDate;
      } else {
        this.formData.startDate = "";
        this.formData.endDate = "";
        this.formData.daterange = "";
      }
      this.showDaterange = false;
    },
    // 获得关联计划列表
    async getPlanTaskList() {
      const specId = this.formData?.specId || "";
      const flowTempId = this.flowDefinitionId || this.formData?.flowDefinitionId;
      const { data } = await flowService.prjPlanTaskFlowList(flowTempId, specId, this.prjId);
      if (data) this.prjPlanList = data || [];
    },
    // 打开关联计划弹框
    openPriPlan() {
      if (this.flowStatus) return;
      if (!this.formData.specId) {
        return Notify({ type: "warning", message: "请先选择专业" });
      }
      this.showPrjPlan = true;
    },
    // 确定关联计划
    priPlanConfirm(option) {
      if (option) {
        this.formData.prjPlanId = option.id || "";
        this.formData.prjPlanName = option.name || "";
      }
      this.showPrjPlan = false;
    },

    // 打开关联文档弹框
    openFileTree() {
      this.$refs.treeLazyH5.showPopup = true;
    },
    // 懒加载方法
    async getFileTree(node, resolve) {
      if (node.level === 0) {
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId: this.prjId
        };
        const { data } = await docService.queryTree(params);
        const list = data.filter(({ folderId }) => folderId !== "recycle");
        const array = list.map((item) => {
          const { childFolder = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            status: item.status,
            uploadType: 2,
            fileVersion: item.fileVersion,
            leaf: childFolder === 0
          };
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data?.folderId,
          isRead: node.data?.isRead,
          priviAll: node.data?.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        await docService.queryTree(params).then(({ data }) => {
          const list = data.map((item) => {
            const { childFolder = 0 } = item;
            return {
              isRead: item.isRead,
              priviAll: item.priviAll,
              folderName: item.folderName,
              folderId: item.folderId,
              isFolder: item.isFolder,
              fileType: item.fileType,
              status: item.status,
              leaf: childFolder === 0,
              fileVersion: item.fileVersion,
              uploadType: 2
            };
          });
          return resolve(list);
        });
      }
    },
    // 设置选中的文件
    async fileCheck(checkList) {
      const list = [];
      // 对于直接选择文件可以先拿出来
      const array = checkList.filter(({ isFolder }) => isFolder === 0);
      const arrayFolder = checkList.filter(({ isFolder }) => isFolder !== 0);
      const array11 = array.map((item) => {
        return {
          fileName: item.folderName,
          fileId: item.folderId,
          fileType: item.fileType,
          isFolder: item.isFolder,
          status: item.status,
          versionIds: item.fileVersion,
          uploadType: 2
        };
      });
      // 选中的文件夹点击确定获取子级数据
      for (const item of arrayFolder) {
        const params = {
          folderId: item.folderId,
          isRead: item.isRead,
          priviAll: item.priviAll,
          noRightClickMenu: true,
          prjId: this.prjId
        };
        await docService.queryTree(params).then(({ data }) => {
          const listData = data.map((item) => {
            return {
              fileName: item.folderName,
              fileId: item.folderId,
              fileType: item.fileType,
              isFolder: item.isFolder,
              status: item.status,
              versionIds: item.fileVersion,
              uploadType: 2
            };
          });
          list.push.apply(list, listData);
        });
      }
      // 将获取到的非文件过滤掉
      const listLocal = list.filter(({ isFolder }) => isFolder === 0);
      // 拼接原来选择的文件
      const floderDataNew = array11.concat(listLocal);
      // 过滤一下重复的
      const res = new Map();
      const floderData = floderDataNew.filter((a) => !res.has(a.fileName) && res.set(a.fileName, 1));
      this.$emit("tableshow", floderData || []);
    }
  }
};
</script>

<style lang="scss" scoped>
.flowForm {
  width: 100%;
}

.oneCell {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
}

.empty {
  height: 200px;
  line-height: 200px;
  text-align: center;
  color: var(--info-color);
  font-size: 16px;
}
</style>
